import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Card, Icon } from '@ui-kitten/components';
import { StyleSheet, View, Image, Dimensions, TouchableOpacity } from 'react-native';
import moment from 'jalali-moment'
import * as RootNavigation from '../../../root.navigation.js';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { setTaskData } from '../../../store/actions/request';
import { useDispatch } from 'react-redux';
import { useIsFocused } from "@react-navigation/native";
const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const NewTask = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='alert-circle'/>
);
const Eye = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='eye'/>
);
const Flag = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flag'/>
);
const Flash = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flash'/>
);
const Person = (props) => (
  <Icon {...props}
    style={[props.style, {width:16,height:16 }]}
    fill = '#9ecbff'
    name='person-outline'/>
);
const Phone = (props) => (
  <Icon {...props}
    style={[props.style, {width:16,height:16 }]}
    fill = '#9ecbff'
    name='phone-call-outline'/>
);
const Calendar = (props) => (
  <Icon {...props}
    style={[props.style, {width:16,height:16 }]}
    fill = '#9ecbff'
    name='calendar-outline'/>
);

const Grid = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    name='grid'/>
);
const Briefcase = (props) => (
  <Icon {...props}
    style={[props.style, {width:30,height:30 }]}
    name='briefcase'/>
);
const Clock = (props) => (
  <Icon {...props}
    style={[props.style, {width:30,height:30 }]}
    name='clock-outline'/>
);
export const Tasks = ({ navigation }) => {
  const isVisible = useIsFocused();
  const [data, setData] = React.useState([]);
  const [today, setToday] = React.useState();
  const dispatch = useDispatch();

  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/invoice/agent_invoices',null, {
      headers: {Authorization: `Bearer ${token}`}
    });
    setData(response.data.allData);
    console.log(response.data.allData);
  }

  React.useEffect(()=>{
    getData()
    setToday(moment().locale('fa').format('YYYY-MM-DD'))
  },[isVisible])

  return (
    <Layout level='2' style={{marginTop:5}}>

    { data.length > 0 ? data.map((data)=>{
        return(
          <Layout level='2'>
          <TouchableOpacity key={data.id} style={{paddingVertical: 4}} onPress={async()=>{
            await dispatch(setTaskData(data))
            RootNavigation.navigate('Doing')
          }}>

            <View style={styles.cardLayout} >
              <Layout style={{...styles.rightContainer, backgroundColor: moment(today).diff(moment(`${data.register_date.split('/')[0]}-${data.register_date.split('/')[1]}-${data.register_date.split('/')[2].split('T')[0]}`), 'days') > 4
                ? '#FFC5AF' : null}}>
                {(data.service_type=='تعمیر' ? <Briefcase fill={
                  moment(today).diff(moment(`${data.register_date.split('/')[0]}-${data.register_date.split('/')[1]}-${data.register_date.split('/')[2].split('T')[0]}`), 'days') > 4
                    ? '#f73b58' : '#7cb8fc'} /> : <Grid fill={
                      moment(today).diff(moment(`${data.register_date.split('/')[0]}-${data.register_date.split('/')[1]}-${data.register_date.split('/')[2].split('T')[0]}`), 'days') > 4
                        ? '#f73b58' : '#7cb8fc'}/>)}
                <Text category='h6' style={{color: moment(today).diff(moment(`${data.register_date.split('/')[0]}-${data.register_date.split('/')[1]}-${data.register_date.split('/')[2].split('T')[0]}`), 'days') > 4
                  ? '#f73b58' : '#7cb8fc'}} appearance='hint'>{data.id}</Text>

              </Layout>
              <Layout style={styles.centerContainer}>
                <View style={{alignItems:'flex-start'}}>
                  <View style={{flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                    <Text appearance='hint' style={{marginTop: 5}}><Person /> </Text>
                    <Text category='h6' appearance='hint' style={{marginHorizontal:5}}>{data.merchant_name}</Text>
                  </View>
                  <View style={{flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                    <Text appearance='hint' style={{marginTop: 5}}><Phone /> </Text>
                    <Text category='p1' appearance='hint' style={{marginHorizontal:5}}>{data.merchant_phone}</Text>
                  </View>
                  <View style={{flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                    <Text appearance='hint' style={{marginTop: 5}}><Calendar /> </Text>
                    <Text category='c2' appearance='hint' style={{marginHorizontal:5}}>تاریخ: {data.register_date ? data.register_date.split('T')[0] : '-'}</Text>
                  </View>
                </View>
                <View style={{alignItems:'flex-end', paddingVertical: 10, justifyContent:'space-between'}}>
                  <Clock
                  fill={
                    moment(today).diff(moment(`${data.register_date.split('/')[0]}-${data.register_date.split('/')[1]}-${data.register_date.split('/')[2].split('T')[0]}`), 'days') > 4
                      ? '#f73b58' : '#7cb8fc'}/>
                  <Text category='p1' style={{ marginTop:8}} status={(!data.status?'success':'primary')}>{(!data.status ? 'جدید' : data.status=='factory' ?'ارسال به کارخانه': data.status == 'deliver' ? 'تحویل به مشتری' : 'در جریان')}</Text>
                </View>
              </Layout>

            </View>
          </TouchableOpacity>
          </Layout>
        )
      }) :
        <View style={{alignItems:'center', paddingTop: 10}}>
        <Image source= {require('../../../assets/signup.png')} style={{width:width*0.5, height:width*0.5}} />
        <Text appearance='hint' style={{margin:25, textAlign:'center'}}>کار جدیدی برای اختصاص به شما وجود ندارد.</Text>
        </View>
    }
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    marginHorizontal: 15,
    marginVertical: 8,
    color:'#5469215'
  },
  cardLayout:{
    flexDirection:'row',
    justifyContent:'space-between',
  },
  rightContainer:{
    flex: 1,
    alignItems:'center',
    justifyContent: 'center',
    borderRadius: 10,
    marginHorizontal: 7,
    borderWidth:1,
    borderColor: '#9ecbff',
    paddingHorizontal:10,

  },
  leftContainer:{
    alignItems:'flex-end'
  },
  centerContainer:{
    flex:5,
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems:'flex-start',
      borderRadius: 10,
      paddingHorizontal: 8,
      marginHorizontal: 7,
      borderWidth:1,
      borderColor: '#9ecbff',
  },
});
